import { useState } from "react";
import { Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap";
import Swal from "sweetalert2";

const tiposAsistencia = [
    { value: 'tecnica', label: 'Soporte técnico' },
    { value: 'facturacion', label: 'Facturación y pagos' },
    { value: 'pld', label: 'PLD y cumplimiento' },
    { value: 'capacitacion', label: 'Capacitación' },
    { value: 'otro', label: 'Otro' }
];

const initialSolicitud = {
    tipo: 'tecnica',
    asunto: '',
    correo: localStorage.getItem('psaAgent') || '',
    descripcion: ''
};

export default function Asistencia() {
    const [solicitud, setSolicitud] = useState(initialSolicitud);
    const [error, setError] = useState('');

    function handleChange(name) {
        return function (e) {
            setSolicitud({ ...solicitud, [name]: e.target.value });
            setError('');
        };
    }

    function handleSubmit(e) {
        e.preventDefault();
        const asunto = solicitud.asunto.trim();
        const descripcion = solicitud.descripcion.trim();
        const correo = solicitud.correo.trim();

        if (!asunto) {
            setError('Indica un asunto breve para tu solicitud.');
            return;
        }
        if (!correo) {
            setError('Indica un correo de contacto.');
            return;
        }
        if (!descripcion) {
            setError('Describe tu solicitud de asistencia.');
            return;
        }

        console.log('Solicitud de asistencia (solo frontend):', {
            ...solicitud,
            asunto,
            correo,
            descripcion,
            enviadaEn: new Date().toISOString()
        });

        Swal.fire({
            icon: 'success',
            title: 'Solicitud registrada (simulado)',
            text: 'Recibimos tu solicitud. El equipo de soporte te contactará pronto. No. de solicitud: #1234567890',
            confirmButtonText: 'Continuar',
            confirmButtonColor: '#6c757d'
        });

        setSolicitud({
            ...initialSolicitud,
            correo: solicitud.correo
        });
    }

    return (
        <div>
            <h3>Asistencia</h3>
            <Row>
                <Col>
                    <p>¿Necesitas ayuda? Aquí podrás solicitar asistencia técnica.</p>
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <Form onSubmit={handleSubmit}>
                        {error && <p className="text-danger small">{error}</p>}
                        <FormGroup>
                            <Label for="tipoAsistencia">Tipo de asistencia</Label>
                            <Input
                                type="select"
                                id="tipoAsistencia"
                                className="FormInput"
                                value={solicitud.tipo}
                                onChange={handleChange('tipo')}
                            >
                                {tiposAsistencia.map((tipo) => (
                                    <option key={tipo.value} value={tipo.value}>{tipo.label}</option>
                                ))}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="asuntoAsistencia">Asunto *</Label>
                            <Input
                                type="text"
                                id="asuntoAsistencia"
                                value={solicitud.asunto}
                                onChange={handleChange('asunto')}
                                placeholder="Ej. Error al cargar expedientes PLD"
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="correoAsistencia">Correo de contacto *</Label>
                            <Input
                                type="email"
                                id="correoAsistencia"
                                value={solicitud.correo}
                                onChange={handleChange('correo')}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="descripcionAsistencia">Descripción *</Label>
                            <Input
                                type="textarea"
                                id="descripcionAsistencia"
                                rows={5}
                                value={solicitud.descripcion}
                                onChange={handleChange('descripcion')}
                                placeholder="Cuéntanos qué ocurre, pasos para reproducirlo y mensajes de error si los hay."
                                required
                            />
                        </FormGroup>
                        <Button className="text-center mt-3" color="secondary" type="submit">Enviar solicitud</Button>
                    </Form>
                </Col>
            </Row>
        </div>
    );
}
